module.exports = __webpack_public_path__ + "img/theme13.b4c7afdc.png";